const MAIN_DIV_CLASS = "flex items-center content-center place-content-center";
export const MAIN_NORMAL_Bodly = "bodyly mt-16 max-w-[620px]  main-bodly";
export const MAIN_MIDDLE_Bodly = "flex items-center h-[85vh] justify-center max-w-[750px] sm:px-12 w-full m-auto -mt-16 middle-bodly";
export const GRID_LAYOUT_2 = "max-w-[400px] m-auto grid grid-cols-2 mt-5 pt-5 justify-items-center mt-2 sm:mb-5 mb-5 sm:gap-7 gap-3 mob-grid-2";
export const GRID_LAYOUT_3 = "max-w-[654px] m-auto grid sm:grid-cols-3 grid-cols-2 mt-5 pt-5 justify-items-center px-8 mt-2 sm:mb-5 mb-5 sm:gap-7 gap-3  mob-grid-3";
export const TITLE_DIV_CLASS = "mc1 w-full overflow-x-hidden mt-5";
export const NEXT_DIV_CLASS = "w-full pt-2 next-btn-mob";

export default MAIN_DIV_CLASS;